import React from 'react';
import LoadSpinner from '../misc/LoadSpinner';
import { Link } from 'react-router-dom';
import { entityListExtra } from '../../interfaces/generic-entity.interface';
import Modal from '../misc/Modal';
import EntityListSearch from 'pages/lists/EntityListSearch';

interface entityListProps {
    list: entityListExtra[] | null;
    type: 'sectors' | 'institutions' | 'committees' | 'issues' | 'subjects';
    open: boolean;
    handleClose: () => void;
}

const ModalEntityList = ({ type, list, open, handleClose }: entityListProps) => {
    return (
        <Modal open={open} onClose={handleClose} title={`Select ${type}`}>
            <div className="lg:max-h-[75vh] max-h-72 overflow-y-auto py-2">
                <EntityListSearch type={type} list={list || []} embedded />
                {list === null ? (
                    <LoadSpinner />
                ) : (
                    list.map((entity, idx) => (
                        <div className="bg-white flex flex-row items-center justify-between p-2 my-2 mr-2 shadow-sm rounded-md text-md">
                            <Link
                                key={idx}
                                to={`/${type}/${entity.code}?name=${entity.title}`}
                                className="pl-2 text-blue-400 font-medium hover:underline"
                                onClick={handleClose}
                            >
                                <div>{entity.title}</div>
                            </Link>
                        </div>
                    ))
                )}
            </div>
        </Modal>
    );
};

const ModalEntityListV2 = ({ type, list, open, handleClose }: entityListProps) => {
    return (
        <Modal open={open} onClose={handleClose} title={`Select ${type}`}>
            <div className="lg:max-h-[75vh] max-h-72 overflow-y-auto py-2">
                <EntityListSearch type={type} list={list || []} embedded />
                {list === null ? (
                    <LoadSpinner />
                ) : (
                    list.map((entity, idx) => (
                        <div className="bg-white flex flex-row items-center justify-between p-2 my-2 mr-2 shadow-sm rounded-md text-md">
                            <Link
                                key={idx}
                                to={`/${type}/${entity.code}?name=${entity.title}`}
                                className="pl-2 text-blue-400 font-medium hover:underline"
                                onClick={handleClose}
                            >
                                <div>{entity.title}</div>
                            </Link>
                        </div>
                    ))
                )}
            </div>
        </Modal>
    );
};

export default ModalEntityList;
export { ModalEntityListV2 };
